import { userFields } from './users';

const gradingFields = {
  CARD_NAME: 'Card Name',
  CARD_NUMBER: 'Card Number',
  DECLARED_VALUE: 'Declared Value',
  GRADE: 'Grade',
  HARD_CASE: 'Hard Case',
  ORDER: 'Order',
  ORDER_NUMBER: 'Order Number (from Order)',
  ORDER_STATUS: 'Status (from Order)',
  SERVICE_LEVEL: 'Service Level',
  SET: 'Set',
  SUBMISSION_NUMBER: 'Submission Number',
  USER_ID: userFields.USER_ID,
  USER_NAME: userFields.USER_NAME,
  YEAR: 'Year',
};

const gradingOrdersFields = {
  CHECKED_IN: 'Checked In',
  COMPLETED: 'Completed',
  ORDER_NUMBER: 'Order Number',
  STATUS: 'Status',
};

const dciGradingActions = {
  SEND_HOME: 'Send home',
  SEND_TO_CONSIGNMENT: 'Send to consignment',
  SEND_TO_GRADING: 'Send to grading',
};

const dciGradingFields = {
  ...gradingFields,
  DCI_ACTION: 'Action',
  DCI_GRADE: 'DCI Grade',
  DECLARED_VALUE: 'Declared Value',
  DESTINATION: 'Destination',
  SERVICE_LEVEL: 'Service Level',
};

const dciSubmissionsFields = {
  RETURN_TRACKING_NUMBER: 'Return Tracking Number',
  SUBMISSION_NUMBER: 'Submission Number',
};

export {
  dciGradingActions,
  dciGradingFields,
  dciSubmissionsFields,
  gradingFields,
  gradingOrdersFields,
};
